import { render, staticRenderFns } from "./DocUploadBlock.vue?vue&type=template&id=28766c55&scoped=true&"
import script from "./DocUploadBlock.vue?vue&type=script&lang=ts&"
export * from "./DocUploadBlock.vue?vue&type=script&lang=ts&"
import style0 from "./DocUploadBlock.vue?vue&type=style&index=0&id=28766c55&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28766c55",
  null
  
)

export default component.exports